import { render, staticRenderFns } from "./TransferRequestList.vue?vue&type=template&id=63e9fb02&"
import script from "./TransferRequestList.vue?vue&type=script&lang=js&"
export * from "./TransferRequestList.vue?vue&type=script&lang=js&"
import style0 from "./TransferRequestList.vue?vue&type=style&index=0&id=63e9fb02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports